import { inject, ref } from 'vue'
import { storeToRefs } from 'pinia'
import { useRouter } from 'vue-router'
import { userService } from 'services/users.service'
import { userStore } from 'store/user.store'

export default function useProfile() {
  const context = inject('context')
  const router = useRouter()

  const { user } = storeToRefs(userStore())
  const { patchProfile } = userService()

  const profileId = ref(context.user?.profile_id)

  async function setLanguageProfile(lang) {
    try {
      await patchProfile(profileId.value, {
        linguagem: lang,
      })
    } catch (error) {
      console.error(error)
    } finally {
      window.location.reload()
    }
  }

  return {
    user,
    setLanguageProfile,
  }
}
